import {
  InvitationsRequest,
  postUserInvitation,
  SuccessResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { handleSuccess, Self } from '../common';

function* userInvitationRequest(
  self: Self,
  body: InvitationsRequest
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield postUserInvitation(body);
    return handleSuccess(self, response as SuccessResponse);
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default userInvitationRequest;
